export default "immagini/hstaff.jpg"